export const virtuousSelectors = {
  getVirtuousApiKeys: state => state.virtuous.apiKeysDetails.results,
  isVirtuousApiKeysFetching: state => state.virtuous.apiKeysDetails.isFetching,
};
